import React, { useContext } from "react";
import cn from "classnames";
import styles from "./styles.module.scss";
import { CaptionSavingSpaceWhenEmpty } from "../Typography";
import { SpacingBox, ClickableBox } from "../Boxes";
import {
  getCollInfoForProduct,
  getProductColorsForNumber,
  getProductFrontImageForNumber,
} from "../../selectors";
import AppContext from "../../AppContext";
import { ProductImage } from "./ProductImage";
import { ProductName } from "./ProductName";
import { ProductColors } from "./ProductColors";
import { If } from "../Conditional";
import { imageUrlForList } from "../../utils/products";

import kollInfo from "./kollinfo.png";

const Colors = (props) => <ProductColors colors={props.colors} />;

export const ProductCard = ({
  product,
  colours,
  tischOffensiveId,
  onClick,
  className,
}) => {
  const context = useContext(AppContext);
  const collInfo = getCollInfoForProduct(context, product);
  const allColors = getProductColorsForNumber(context)(product.number);

  let visibleColours = allColors;
  if (colours && colours.length > 0) {
    visibleColours = allColors.filter((a) => colours.includes(a.code));
  }
  visibleColours = visibleColours.sort();

  const selectedColour = visibleColours[0];
  const image = getProductFrontImageForNumber(context)(
    product.number,
    selectedColour.code,
  );

  const onSelect = () => {
    if (tischOffensiveId) {
      onClick(product.number, selectedColour.code, tischOffensiveId);
    } else {
      onClick(product.number, selectedColour.code);
    }
  };

  /*
  Missing some caching
  const { sortedListOfPrices, currency } = getLowerPriceForProductAndColor(
    sizes,
    context.actions,
    context,
    colors[0],
    product,
    currentOrder,
  );

         {sortedListOfPrices && (
          <Paragraph>
            {`${translate('price.from')} `}
            {formatMoney(_.first(sortedListOfPrices), currency)}
          </Paragraph>
        )}
  */

  return (
    <ClickableBox
      onClick={onSelect}
      className={cn(styles.productCard, className)}
    >
      <ProductImage
        img={imageUrlForList(image.front)}
        imgOnHover={imageUrlForList(image.back)}
      />
      <If condition={collInfo}>
        {() => (
          <img
            alt="collinfo"
            className={styles.infoCircleIcon}
            src={kollInfo}
          />
        )}
      </If>
      <SpacingBox marginTop="lg">
        <CaptionSavingSpaceWhenEmpty>
          {product.materialInfo}
        </CaptionSavingSpaceWhenEmpty>
        <ProductName name={product.name} />

        <Colors context={context} colors={visibleColours} />
      </SpacingBox>
    </ClickableBox>
  );
};

ProductCard.defaultProps = {
  onClick: () => {},
};
